var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserId(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 9h5m-5 2h3m-5.5-1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM7.659 13h2.682c.241 0 .362 0 .47.015.373.053.696.24.877.508.053.077.09.17.167.353.092.22.137.331.144.42.022.314-.233.598-.611.68-.107.024-.252.024-.542.024H7.154c-.29 0-.435 0-.542-.023-.378-.083-.633-.367-.61-.68.006-.09.051-.2.143-.421.076-.184.114-.276.167-.353.18-.268.504-.454.877-.508.108-.015.229-.015.47-.015ZM6 17h12c.943 0 1.414 0 1.707-.293C20 16.414 20 15.943 20 15V8c0-.943 0-1.414-.293-1.707C19.414 6 18.943 6 18 6H6c-.943 0-1.414 0-1.707.293C4 6.586 4 7.057 4 8v7c0 .943 0 1.414.293 1.707C4.586 17 5.057 17 6 17Z",
    stroke: "#464455",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserId);
export default __webpack_public_path__ + "static/media/user-id.6956c9d19f907373fe6c43c5d9889602.svg";
export { ForwardRef as ReactComponent };